<template>
  <main>
    <header class="header fixed up priority-4">
      <div class="f-center">
        <a class="c-pointer priority-3 mr-3" href="https://www.union.sk" target="_blank">
          <i class="icon icon--union priority-2"></i>
        </a>
      </div>
    </header>

    <section class="wrapper align-items-center f-column min-win-height">
      <h2 class="font-center pr-2 pl-2">Qualified Electronic Signature on the Application</h2>
      <div class="container-900 mb-children-2 pb-6 pt-3">
        <div class="snack-bar orange">
          <div class="flex align-items-start">
            <i class="icon icon--info-white mr-1"></i>
            <p class="font-white">
    Attention! Citizens with an electronic identity card (eID) issued by June 2021 will only be able to use a qualified electronic signature
    until the end of 2022 due to the expiry of the electronic chip. In order to be able to sign an application form with a qualified electronic
    signature from 2023 onwards, a new ID card must be obtained. For more information, click
    <a href="https://www.slovensko.sk/sk/oznamy/detail/_mam-si-vymenit-eid-aby-mi-v-r" target="_blank"><u>here</u></a>
  </p>
          </div>
        </div>
      </div>
      <div class="container-1120">
        <div class="container-full container-white">
          <p class="mb-4 width-10 font-center font-left-1024 mb-2-1024 font-dark">
            <strong>
    You are about to sign a document using an electronic ID card, a process consisting of 5 steps.
    The result of the e-signature verification will be sent to your e-mail. To successfully submit
    a qualified electronic signature, you will need the following:
  </strong>
          </p>

          <div class="width-10 flex f-column-1024 justify-content-center align-items-start mr-children-2 required-things">
            <div class="f-center-column font-center">
              <i class="icon icon--eID"></i>
              <p>You must have an electronic ID card with a chip (eID card).</p>
            </div>

            <div class="f-center-column font-center">
              <i class="icon icon--enter-bok"></i>
              <p>
    You must have your eID card activated for electronic signatures and have a BOK code assigned to it.
  </p>
            </div>

            <div class="f-center-column font-center">
              <i class="icon icon--shield"></i>
              <p>
    You need to know your KEP PIN and have certificates to create an electronic signature installed.
  </p>
            </div>

            <div class="f-center-column font-center">
              <i class="icon icon--delivery-type"></i>
              <p>
    You must have the
    <a class="font-green" href="https://www.slovensko.sk/_img/CMS4/Navody/Nove_ES/navod_vytvorenie_kep_dsigner.pdf" target="_blank"><u>following apps</u></a>
    installed on your computer.
  </p>
            </div>

            <div class="f-center-column font-center">
              <i class="icon icon--reader"></i>
              <p>You need a card reader and associated drivers installed on your computer.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="cta-buttons width-10 f-center mb-8 priority-6">
        <div class="width-10 width-9-768 f-center mr-children-2 justify-content-end-768 align-items-center-768">
          <update-signature-type-redirection></update-signature-type-redirection>

          <button
            class="button-green continue"
            @click="$router.push({ name: 'EID', query: $route.query })"
          >
            <div>Sign</div>
            <i class="desktop-arrow ml-2 icon icon--arrow-right"></i>
            <i class="mobile-arrow icon icon--arrow-right-mobile" style="vertical-align: middle;"></i>
          </button>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import lead from '@/mixins/lead';
import UpdateSignatureTypeRedirection from '@/components/signatures/UpdateSignatureTypeRedirection.vue';
import GA from '@/mixins/GA';

export default {
  name: 'EIDIntro',
  components: { UpdateSignatureTypeRedirection },
  props: ['model', 'errors'],
  mixins: [lead, GA],
  mounted() {
    if (!this.$route.query.lead) {
      this.saveLead(10, 'UZP EID');
    }
    this.funnelStep('epodpis');
  },
};
</script>

<style lang="scss" scoped>
  .required-things {
    @media (max-width: 1024px) {
      justify-content: flex-start;
      align-items: flex-start;
    }

    > * {
      width: 20%;
      flex-shrink: 0;
      p { font-size: 15px; }

      i {
        flex-shrink: 0;
      }

      @media (max-width: 1024px) {
        width: 100%;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        text-align: left;
        margin-right: 0;
        margin-bottom: 15px;
        &:last-child { margin-bottom: 0; }

        i {
          margin-right: 15px;
        }
      }
    }
  }
</style>
